import { ContextHolder } from '@frontegg/react';
import { clearDebugData, isDebugMode } from '../../debug/debugUser';

export function logout() {
  if (isDebugMode()) {
    clearDebugData();
    window.location.reload();
    return;
  }
  const baseUrl = ContextHolder.getContext().baseUrl;
  window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location.origin}`;
}
